import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { PublicLayout } from "@/components/PublicLayout";
import { AppLayout } from "@/components/AppLayout";
import { ProtectedRoute, AdminRoute } from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Plans from "@/pages/Plans";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Predictor from "@/pages/Predictor";
import Payment from "@/pages/Payment";
import PaymentHistory from "@/pages/PaymentHistory";
import HistoryPage from "@/pages/History";
import InboxPage from "@/pages/Inbox";
import Support from "@/pages/Support";
import Account from "@/pages/Account";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/plans" element={<Plans />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/predictor" element={<Predictor />} />
              <Route path="/payment/:planName" element={<Payment />} />
              <Route path="/payment-history" element={<PaymentHistory />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/inbox" element={<InboxPage />} />
              <Route path="/support" element={<Support />} />
              <Route path="/account" element={<Account />} />
            </Route>

            <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          </Routes>
        </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
